import React from 'react';
import { Link } from 'react-router-dom';
import PrescriptionElement from './PrescriptionElement';

export default function PrescriptionCard({ route, prescription, points, ...rest }) {
    return (
      <Link
        key={rest.key}
        to={route}
        onClick={rest.onClick}
      >
        <div className="card white p-4 mb-3">
          <PrescriptionElement
            prescription={prescription}
            {...rest}
          />
        </div>
      </Link>
    )
  }
  